import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-0"}]]

const IconNumber9Small = createReactComponent('outline', 'number-9-small', 'Number9Small', __iconNode);

export default IconNumber9Small;